import { useEffect, useState } from "react";
import axios from "axios";
import { CONTENT_ROUTES } from "../routes/content-routes";
import Header from "../components/header";
import Footer from "../components/footer";
import FormContact from "../components/form-contact";
import { Helmet } from "react-helmet";
import { useUtilities } from "../hooks/utilities";
import { GoogleReCaptchaProvider } from "react-google-recaptcha-v3";

export default function Contact() {
  const [page, setPage] = useState({});
  const [pageMedia, setPageMedia] = useState([]);
  let { getMetaSnippet, getSeoTitle, getSeoDescription } = useUtilities();

  useEffect(() => {
    axios
      .get(CONTENT_ROUTES.POST_PAGE("/pages", "contact-nant-power"))
      .then((res) => {
        const pageResponse = res.data?.length ? res.data[0] : {};
        setPage(pageResponse);
        //Get page media
        axios
          .get(CONTENT_ROUTES.MEDIA_BY_PAGE(pageResponse?.id))
          .then((res) => {
            setPageMedia(res.data);
          });
      })
      .catch((err) => {})
      .finally(() => {});
  }, []);

  return (
    <>
      <Helmet>
        <title>
          {getSeoTitle(page, page?.title?.rendered + ` - Nant Power`)}
        </title>
        <meta
          name="description"
          content={getSeoDescription(
            page,
            getMetaSnippet(page?.content?.rendered)
          )}
        />
      </Helmet>
      <Header />
      <main>
        <section className=" relative bg-[#0071b9]">
          <div className="absolute top-0 left-0  w-1/4 h-full -z-10 lg:block hidden"></div>
          <div className="absolute top-0 right-0 w-1/2 h-full -z-10 lg:block hidden"></div>
          <div className="xl:container xl:mx-auto">
            <div className="lg:flex">
              <article className="w-full xl:w-2/5 xl:mb-0 xl:pr-10 xl:pl-0 md:py-16 pt-16 pb-8 px-8 text-white">
                <h1 className="pb-5 text-4xl font-semibold text-white">
                  {page?.title?.rendered}
                </h1>
                <div
                  dangerouslySetInnerHTML={{
                    __html: page?.content?.rendered,
                  }}
                />
              </article>
              <div
                className="relative w-full xl:w-3/5 xl:p-16 px-8 md:pt-16 pt-10 pb-48 bg-no-repeat bg-[right_0px_center] bg-cover"
                style={{
                  backgroundImage: `url(${
                    pageMedia?.find(
                      (media) => media?.id === page?.featured_media
                    )?.source_url
                  })`,
                }}
              ></div>
            </div>
          </div>
        </section>
        <section className="relative flex bg-[#045994]">
          <div className="absolute top-0 left-0  w-1/4 h-full -z-10 lg:block hidden"></div>

          <div className="lg:flex xl:container xl:mx-auto w-full ">
            <div className="xl:w-2/5 lg:w-3/6 md:p-16 md:pl-0 px-8 py-16">
              <div className="flex mb-2">
                <img
                  className="mr-5 h-12 -mt-2"
                  src="/images/electric-bolt-solid.svg"
                  alt="Nant Power Project Icon"
                />
                <span className="text-xl font-bold text-white">
                  Email us now
                </span>
              </div>
              <GoogleReCaptchaProvider reCaptchaKey="6LfcxHorAAAAAAdbYDy1YHUNOxmQeE9lrjMZa0tX">
                <FormContact />
              </GoogleReCaptchaProvider>
            </div>
            <div className="relative xl:w-3/5 lg:w-3/6 google_map md:flex">
              <div
                className="md:w-1/2 w-full"
                dangerouslySetInnerHTML={{
                  __html: page?.acf?.google_map,
                }}
              />
              <div
                className="md:w-1/2 w-full"
                dangerouslySetInnerHTML={{
                  __html: page?.acf?.google_map_site,
                }}
              />
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </>
  );
}
